import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import Icon from './Icon';
import Reveal from './Reveal';
import SectionHead from './SectionHead';
import { services } from '../data/site';

const Services = ({ showHead = true, alt = false }) => {
  return (
    <section id="services" className={`section ${alt ? 'section-alt' : ''}`}>
      <div className="container">
        {showHead && (
          <SectionHead
            eyebrow="What we do"
            title="Every digital need of your institute"
            subtitle="Nine services, one accountable partner. Choose what you need today and add more as your institute grows."
          />
        )}

        <Reveal className="services-grid">
          {services.map((service) => (
            <Link key={service.id} to={service.link} className="service-card">
              <div className="service-icon">
                <Icon name={service.icon} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="service-outcome">
                <span>{service.outcome}</span>
                <FiArrowUpRight />
              </div>
            </Link>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Services;
